export default __webpack_public_path__ + "static/media/Frame 564.128a1c0b.svg";